import React from 'react';
import PropTypes from '../../utils/PropTypes';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: 'h-6 w-6',
};

const WorkspaceIcon = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
    >
        <path
            d="M12 5.021C11.0717 5.021 10.1815 5.38975 9.52513 6.04612C8.86875 6.7025 8.5 7.59274 8.5 8.521C8.5 9.44925 8.86875 10.3395 9.52513 10.9959C10.1815 11.6522 11.0717 12.021 12 12.021C12.9283 12.021 13.8185 11.6522 14.4749 10.9959C15.1313 10.3395 15.5 9.44925 15.5 8.521C15.5 7.59274 15.1313 6.7025 14.4749 6.04612C13.8185 5.38975 12.9283 5.021 12 5.021ZM12 7.021C12.3978 7.021 12.7794 7.17903 13.0607 7.46034C13.342 7.74164 13.5 8.12317 13.5 8.521C13.5 8.91882 13.342 9.30035 13.0607 9.58166C12.7794 9.86296 12.3978 10.021 12 10.021C11.6022 10.021 11.2206 9.86296 10.9393 9.58166C10.658 9.30035 10.5 8.91882 10.5 8.521C10.5 8.12317 10.658 7.74164 10.9393 7.46034C11.2206 7.17903 11.6022 7.021 12 7.021ZM5.5 8.021C4.83696 8.021 4.20107 8.28439 3.73223 8.75323C3.26339 9.22207 3 9.85795 3 10.521C3 11.461 3.53 12.271 4.29 12.701C4.65 12.901 5.06 13.021 5.5 13.021C5.94 13.021 6.35 12.901 6.71 12.701C7.08 12.491 7.39 12.191 7.62 11.831C6.89 10.881 6.5 9.721 6.5 8.521C6.5 8.431 6.5 8.331 6.5 8.241C6.2 8.101 5.86 8.021 5.5 8.021ZM18.5 8.021C18.14 8.021 17.8 8.101 17.5 8.241C17.5 8.331 17.5 8.431 17.5 8.521C17.5 9.721 17.11 10.881 16.38 11.831C16.5 12.021 16.63 12.171 16.78 12.321C16.94 12.471 17.1 12.601 17.29 12.701C17.65 12.901 18.06 13.021 18.5 13.021C18.94 13.021 19.35 12.901 19.71 12.701C20.47 12.271 21 11.461 21 10.521C21 9.85795 20.7366 9.22207 20.2678 8.75323C19.7989 8.28439 19.163 8.021 18.5 8.021ZM12 14.021C9.66 14.021 5 15.191 5 17.521V19.021H19V17.521C19 15.191 14.34 14.021 12 14.021ZM4.71 14.571C2.78 14.801 0 15.781 0 17.521V19.021H3V17.091C3 16.081 3.69 15.241 4.71 14.571ZM19.29 14.571C20.31 15.241 21 16.081 21 17.091V19.021H24V17.521C24 15.781 21.22 14.801 19.29 14.571ZM12 16.021C13.53 16.021 15.24 16.521 16.23 17.021H7.77C8.76 16.521 10.47 16.021 12 16.021Z"
            fill="currentColor"
        />
    </svg>
);

WorkspaceIcon.propTypes = propTypes;
WorkspaceIcon.defaultProps = defaultProps;

export default React.memo(WorkspaceIcon);
